import { TColorProp, useTheme } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';
import { IFCWithChildren } from '~/common/interfaces/i-fc-with-children';

import { BadgeContainer } from './styles';
import { Typography } from '../Typography';

interface IBadgeProps {
  color?: TColorProp;
  textColor?: TColorProp;
}

export const Badge: IFCWithChildren<IBadgeProps> = ({
  children,
  color = 'primary',
  textColor = 'neutral.0',
}) => {
  const theme = useTheme();
  return (
    <BadgeContainer color={getThemeColor(theme, color)}>
      <Typography.Label size="x-small" color={textColor}>
        {children}
      </Typography.Label>
    </BadgeContainer>
  );
};
